{
  "DeleteReminder": "Delete reminder",
  "DismissAlert": "Dismiss",
  "DismissAllReminders": "Dismiss all reminders",
  "DismissReminder": "Dismiss reminder",
  "EditReminder": "Edit reminder",
  "RemindMe15Min": "Remind me in 15 minutes",
  "RemindMe5Min": "Remind me in 5 minutes",
  "RemindMe60Min": "Remind me in an hour",
  "RemindMeTomorrow": "Remind me tomorrow",
  "Reminder": "Reminder",
  "Reminders": "Reminders",
  "Snooze": "Remind me"
} 
